import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export default {
  path: "/projects",
  name: "Projects View",
  meta: { sectionAccess: "PROJECTS", redirects: true },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "dossier",
      name: "Dossiers",
      redirect: { name: "Dossier List" },
      meta: { permissions: [PermissionEnum.PROJECTS_DOSSIER] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Dossier List",
          component: () => import("@/views/auth/projects/dossiers/Dossiers.vue"),
        },
        {
          path: "new",
          name: "Create Dossier",
          component: () => import("@/views/auth/projects/dossiers/CreateDossier.vue"),
        },
        {
          path: "detail/:id",
          name: "Dossier Detail",
          redirect: { name: "Dossier Economic Summary" },
          component: () => import("@/views/auth/projects/dossiers/DossierDetail.vue"),
          props: true,
          children: [
            {
              path: "summary",
              name: "Dossier Economic Summary",
              component: () => import("@/modules/dossiers/tabs/EconomicSummaryTab.vue"),
              props: true,
            },
            {
              path: "projects",
              name: "Dossier's Projects",
              component: () => import("@/modules/dossiers/tabs/ProjectsTab.vue"),
              props: true,
            },
            {
              path: "certifications",
              name: "Dossier's Certifications",
              component: () => import("@/modules/dossiers/tabs/CertificationsTab.vue"),
              props: true,
            },
            {
              path: "valuations",
              name: "Dossier's Valuations",
              component: () => import("@/modules/dossiers/tabs/ValuationsTab.vue"),
              props: true,
            },
            {
              path: "worksheets",
              name: "Dossier's Worksheets",
              component: () => import("@/modules/dossiers/tabs/WorksheetsTab.vue"),
              props: true,
            },
            {
              path: "expenses",
              name: "Dossier's Expenses",
              component: () => import("@/modules/dossiers/tabs/ExpensesTab.vue"),
              props: true,
            },
            {
              path: "on-calls",
              name: "Dossier's On Calls",
              component: () => import("@/modules/dossiers/tabs/DossierOnCallsTab.vue"),
              props: true,
            },
          ],
        },
        {
          path: "edit/:id",
          name: "Edit Dossier",
          component: () => import("@/views/auth/projects/dossiers/EditDossier.vue"),
          props: true,
        },
      ],
    },
    {
      path: "worksheets",
      name: "Worksheets",
      meta: { permissions: [PermissionEnum.PROJECTS_WORKSHEET] },
      redirect: { name: "Worksheet List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Worksheet List",
          component: () => import("@/views/auth/projects/worksheets/WorksheetList.vue"),
          props: true,
        },
        {
          path: "detail/:id?",
          name: "Worksheet Detail",
          redirect: { name: "Worksheet Sidebar" },
          components: {
            default: () => import("@/views/auth/projects/worksheets/WorksheetDetail.vue"),
          },
          props: true,
          children: [
            {
              path: "",
              name: "Worksheet Sidebar",
              components: {
                sidebar: () => import("@/modules/worksheets/view-parts/worksheet-detail/WorksheetRightSidebar.vue"),
              },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "calendar/:id?/:paramDate?",
      name: "Calendar Report",
      meta: { permissions: [PermissionEnum.PROJECT_CALENDAR] },
      component: () => import("@/views/auth/projects/CalendarReport.vue"),
      props: true,
    },
    {
      path: "projects",
      name: "Projects",
      redirect: { name: "Projects List" },
      meta: { permissions: [PermissionEnum.PROJECTS_PROJECT] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Projects List",
          component: () => import("@/views/auth/projects/projects/ProjectList.vue"),
        },
        {
          path: "edit/:id",
          name: "Edit Project",
          component: () => import("@/views/auth/projects/projects/EditProject.vue"),
          props: true,
        },
        {
          path: "new",
          name: "New Project",
          component: () => import("@/views/auth/projects/projects/NewProject.vue"),
        },
        {
          path: "copy/:id",
          name: "Copy Project",
          component: () => import("@/views/auth/projects/projects/CopyProject.vue"),
          props: true,
        },
        {
          path: "detail/:id",
          name: "Project Detail",
          redirect: { name: "Project Resources" },
          component: () => import("@/views/auth/projects/projects/ProjectDetail.vue"),
          props: true,
          children: [
            {
              path: "contacts",
              name: "Project Contacts",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectContactsTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "expenses",
              name: "Project Expenses",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectExpensesTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "on-calls",
              name: "Project On Calls",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectOnCallsTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectOnCallsSidebar.vue"),
              },
              props: true,
            },
            {
              path: "worksheets",
              name: "Project Worksheets",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectWorksheetsTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "economic",
              name: "Project Economic",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectEconomicTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "documentation",
              name: "Project Documentation",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectDocumentationTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "worksheet-documentation",
              name: "Project Worksheet Documentation",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectWorksheetDocumentationTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "task-files",
              name: "Project Task Files",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectTaskFilesTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "technical-office",
              name: "Project Technical Office",
              meta: { permissions: [PermissionEnum.PROJECT_TECHNICAL_REPORT] },
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectTechnicalOfficeTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "configuration",
              name: "Project Configuration",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectConfigurationTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
            {
              path: "resources",
              name: "Project Resources",
              components: {
                default: () => import("@/modules/projects/components/tabs/ProjectResourcesTab.vue"),
                sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
              },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "expenses",
      name: "Expenses Layout",
      redirect: { name: "Expenses" },
      meta: { permissions: [PermissionEnum.PROJECTS_EXPENSES] },
      component: () => import("@/views/auth/projects/Expenses.vue"),
      children: [
        {
          path: "import",
          name: "Expenses Import",
          components: {
            default: () => import("@/views/auth/projects/Expenses.vue"),
            sidebar: () => import("@/modules/expenses/components/sidebars/ImportExpensesSidebar.vue"),
          },
        },
        {
          path: ":id?",
          name: "Expenses",
          components: {
            default: () => import("@/views/auth/projects/Expenses.vue"),
            sidebar: () => import("@/modules/expenses/components/sidebars/ExpenseSidebar.vue"),
          },
          props: true,
        },
      ],
    },
    {
      path: "expense-sheets",
      name: "Expense Sheets",
      redirect: { name: "Expense Sheets List" },
      meta: { permissions: [PermissionEnum.PROJECTS_EXPENSES] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Expense Sheets List",
          component: () => import("@/views/auth/projects/ExpenseSheets.vue"),
        },
        {
          path: "detail/:id/:expenseId?",
          name: "Expense Sheet Detail",
          redirect: { name: "Expense Sheet Detail Sidebar" },
          component: () => import("@/views/auth/projects/expense-sheets/ExpenseSheetDetail.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Expense Sheet Detail Sidebar",
              components: {
                sidebar: () => import("@/modules/expenses/components/sidebars/ExpenseSheetDetailSidebar.vue"),
              },
              props: {
                sidebar: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: "files",
      name: "Files",
      meta: { permissions: [PermissionEnum.PROJECTS_FILES] },
      redirect: { name: "Reference documents" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "reference-documents/:type?/:id?",
          name: "Reference documents",
          component: () => import("@/views/auth/projects/ReferenceFiles.vue"),
          props: true,
        },
        {
          path: "general-documents",
          name: "General documents",
          redirect: { name: "General Documents List" },
          component: () => import("@/layouts/EmptyLayout.vue"),
          props: true,
          children: [
            {
              path: "list",
              name: "General Documents list",
              components: {
                default: () => import("@/views/auth/projects/general-documentation/GeneralDocumentationList.vue"),
              },
              children: [
                {
                  path: "",
                  name: "General Documents Sidebar",
                  components: {
                    sidebar: () => import("@/modules/files/components/sidebars/GeneralDocumentSidebar.vue"),
                  },
                  props: true,
                },
              ],
              props: true,
            },
          ],
        },
        {
          path: "worksheet-document",
          name: "Worksheet document",
          component: () => import("@/views/auth/projects/WorksheetDocuments.vue"),
          props: true,
        },
      ],
    },
    {
      path: "task-files",
      name: "Task Files",
      meta: { permissions: [PermissionEnum.PROJECTS_TASK_FILES] },
      component: () => import("@/views/auth/projects/TaskFiles.vue"),
    },
    {
      path: "on-calls",
      name: "On Calls",
      meta: { permissions: [PermissionEnum.PROJECTS_ON_CALL] },
      redirect: { name: "On Calls List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "On Calls List",
          component: () => import("@/views/auth/projects/on-call/OnCallList.vue"),
        },
        {
          path: "detail/:id",
          name: "On Call Detail",
          redirect: { name: "On Call Sidebar" },
          component: () => import("@/views/auth/projects/on-call/OnCallDetailLayout.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "On Call Sidebar",
              components: { sidebar: () => import("@/modules/on-calls/components/sidebars/OnCallSidebar.vue") },
              props: true,
            },
          ],
        },
      ],
    },
    {
      name: "Economic analysis",
      path: "economic-analysis",
      meta: { permissions: [PermissionEnum.PROJECTS_ECONOMIC_ANALYSIS] },
      redirect: { name: "Economic analysis - Project List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          name: "Economic analysis - Project List",
          path: "list",
          component: () => import("@/views/auth/projects/EconomicAnalysisProjectList.vue"),
        },
        {
          name: "Economic analysis - Project Detail",
          path: "detail/:id",
          component: () =>
            import("@/modules/projects/view-parts/economic-analysis-detail/EconomicAnalysisProjectDetail.vue"),
          props: true,
        },
      ],
    },
    {
      path: "certifications",
      name: "Certifications",
      redirect: { name: "Certification List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "new/:id",
          name: "New Certification",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          props: true,
          component: () => import("@/views/auth/projects/certifications/CreateCertification.vue"),
        },
        {
          path: "list",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          name: "Certification List",
          component: () => import("@/views/auth/projects/certifications/CertificationList.vue"),
        },
        {
          path: "detail/:id",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_DETAIL] },
          name: "Certification Detail",
          redirect: { name: "Certification Detail's summary" },
          component: () => import("@/views/auth/projects/certifications/CertificationDetail.vue"),
          props: true,
          children: [
            {
              path: "summary",
              name: "Certification Detail's summary",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationSummaryTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "worksheets",
              name: "Certification Detail's Worksheets",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationWorksheetsTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "on-calls",
              name: "Certification Detail's on calls",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationOnCallsTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "projects",
              name: "Certification Detail's Projects",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationProjectsTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "expenses/:expenseId?",
              name: "Certifications' Detail's expenses",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationExpensesTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "invoice/:selectedId?",
              name: "Certifications' Detail's invoice",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationInvoiceTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "economic-analysis",
              name: "Certifications' Detail's Economic Analysis",
              meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
              components: {
                default: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailEconomicAnalysis.vue"
                  ),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
            {
              path: "valuations",
              name: "Certification Detail's Valuations",
              components: {
                default: () => import("@/modules/certifications/components/tabs/CertificationValuationsTab.vue"),
                sidebar: () =>
                  import(
                    "@/modules/certifications/view-parts/certification-detail/CertificationDetailRightSidebar.vue"
                  ),
              },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "invoices",
      name: "Invoices Layout",
      redirect: { name: "Invoices" },
      meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list/:id?",
          name: "Invoices",
          components: {
            default: () => import("@/views/auth/projects/invoices/InvoiceList.vue"),
            sidebar: () => import("@/modules/invoices/components/sidebars/InvoiceDetailSidebar.vue"),
          },
          props: true,
        },
        {
          path: "create",
          name: "Invoices Create",
          component: () => import("@/views/auth/projects/invoices/InvoiceEdit.vue"),
        },
        {
          path: "create-credit-note",
          name: "Credit Notes Create",
          component: () => import("@/views/auth/projects/invoices/InvoiceEdit.vue"),
        },
        {
          path: "edit/:id",
          name: "Invoices Edit",
          component: () => import("@/views/auth/projects/invoices/InvoiceEdit.vue"),
          props: true,
        },
        {
          path: "import",
          name: "Invoices Import",
          components: {
            default: () => import("@/views/auth/projects/invoices/InvoiceList.vue"),
            sidebar: () => import("@/modules/invoices/components/sidebars/ImportInvoicesSidebar.vue"),
          },
        },
      ],
    },
    {
      path: "valuations",
      name: "Valuations",
      redirect: { name: "Valuation List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "new/:id?",
          name: "New Valuation",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          props: true,
          component: () => import("@/views/auth/projects/valuations/CreateValuation.vue"),
        },
        {
          path: "list",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          name: "Valuation List",
          component: () => import("@/views/auth/projects/valuations/ValuationList.vue"),
        },
        {
          path: "detail/:id",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          name: "Valuation Detail",
          component: () => import("@/views/auth/projects/valuations/ValuationDetail.vue"),
          props: true,
        },
        {
          path: "detail/:id/summary",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          name: "Valuation Detail's summary",
          redirect: (to) => ({ name: "Valuation Detail", params: { id: String(to.params.id) } }),
          props: true,
        },
        {
          path: "execution-reports",
          meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
          name: "Execution Report List",
          component: () => import("@/views/auth/projects/valuations/ExecutionReportList.vue"),
        },
      ],
    },
    {
      path: "technical-report",
      name: "Technical Report",
      meta: { permissions: [PermissionEnum.PROJECT_TECHNICAL_REPORT] },
      redirect: { name: "Technical Report List" },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Technical Report List",
          component: () => import("@/views/auth/projects/technical-reports/TechnicalReportList.vue"),
          props: true,
        },
        {
          path: ":id",
          name: "Technical Report Detail",
          redirect: { name: "Technical Report Sidebar" },
          component: () => import("@/views/auth/projects/technical-reports/TechnicalReportDetail.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Technical Report Sidebar",
              components: {
                sidebar: () => import("@/modules/technical-report/sidebars/TechnicalReportSidebar.vue"),
              },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "configuration",
      name: "Dossier Configuration",
      redirect: { name: "Report Templates List" },
      meta: { permissions: [PermissionEnum.PROJECT_REPORT_TEMPLATE] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "report-templates",
          name: "Report Templates",
          component: () => import("@/layouts/EmptyLayout.vue"),
          redirect: { name: "Report Templates List" },
          props: true,
          children: [
            {
              path: "list",
              name: "Report Templates List",
              props: true,
              redirect: { name: "Create Report Template Sidebar" },
              component: () => import("@/views/auth/projects/ReportTemplates.vue"),
              children: [
                {
                  path: "",
                  name: "Create Report Template Sidebar",
                  components: {
                    sidebar: () => import("@/modules/report-templates/sidebars/CreateReportTemplateSidebar.vue"),
                  },
                },
              ],
            },
            {
              name: "Report Template Detail",
              path: ":id",
              component: () => import("@/views/auth/projects/ReportTemplateDetail.vue"),
              redirect: { name: "Report Sections Tab" },
              props: true,
              children: [
                {
                  path: "reports",
                  name: "Technical Reports Tab",
                  components: {
                    default: () => import("@/modules/report-templates/components/TechnicalReportsTab.vue"),
                    sidebar: () => import("@/modules/report-templates/sidebars/ReportSectionSidebar.vue"),
                  },
                  props: {
                    default: (route) => ({ id: route.params.id }),
                    sidebar: (route) => ({ reportTemplateId: route.params.id }),
                  },
                },
                {
                  path: "sections",
                  name: "Report Sections Tab",
                  components: {
                    default: () => import("@/modules/report-templates/components/ReportSectionsTab.vue"),
                    sidebar: () => import("@/modules/report-templates/sidebars/ReportSectionSidebar.vue"),
                  },
                  props: {
                    default: (route) => ({ reportTemplateId: route.params.id }),
                    sidebar: (route) => ({ reportTemplateId: route.params.id }),
                  },
                },
                {
                  path: "edit",
                  name: "Edit Report Template Sidebar",
                  components: {
                    default: () => import("@/modules/report-templates/components/ReportSectionsTab.vue"),
                    sidebar: () => import("@/modules/report-templates/sidebars/EditReportTemplateSidebar.vue"),
                  },
                  props: {
                    default: (route) => ({ reportTemplateId: route.params.id }),
                    sidebar: (route) => ({
                      reportTemplateId: route.params.id,
                      closeRouteName: "Report Template Detail",
                    }),
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
} as RouteRecordRaw;
